export default {
    hours: [
        {hour: 8, minutes: 0},
        {hour: 8, minutes: 30},
        {hour: 9, minutes: 0},
        {hour: 9, minutes: 30},
        {hour: 10, minutes: 0},
        {hour: 10, minutes: 30},
        {hour: 11, minutes: 0},
        {hour: 11, minutes: 30},
        {hour: 12, minutes: 0},
        {hour: 12, minutes: 30},
        {hour: 15, minutes: 30},
        {hour: 16, minutes: 0},
        {hour: 16, minutes: 30},
    ],
    // SUNDAY 0, MONDAY 1, TUESDAY 2, WEDNESDAY 3, THURSDAY 4, FRIDAY 5, SATURDAY 6
    openingDays: [1, 2, 3, 4, 5]
}